import { useCallback, useEffect, useState } from 'react'
import apiFetch from '@wordpress/api-fetch'
import { useBrowerStorage } from '../useBrowserStorage'
import type { Competition } from '../../competitions/types'
import { COMPETITIONS_BOTTOM_BAR_CONFIG } from '../../config/competitionsBottomBarConfig'
import { xorDecipherAndParse } from '../../shared/utils'

export const EMPTY_ARRAY = []
export const USER_COMPETITIONS_VALIDATION = (x: any) => Array.isArray(x) // not very strict

export const useCoupes = (): {
    cachedCoupes: (Competition & {
        structureLibelle: string
        extSaisonId: string
    })[]
} => {
    const { value: cachedCoupes, setValue: setCachedCoupes } = useBrowerStorage<
        (Competition & {
            structureLibelle: string
            extSaisonId: string
        })[]
    >({
        key: COMPETITIONS_BOTTOM_BAR_CONFIG.COUPES.SESSION_STORAGE_KEY,
        defaultValue: EMPTY_ARRAY,
        getItemValidation: USER_COMPETITIONS_VALIDATION,
        persistence: 'sessionStorage',
    })

    const [shouldFetch, setShouldFetch] = useState(cachedCoupes.length === 0)

    const fetchCoupes = useCallback(async () => {
        if (shouldFetch) {
            try {
                const data = await apiFetch<string>({
                    path: `competitions/v1/competitions/coupes-de-france`,
                })
                const jsonData = xorDecipherAndParse(data)
                setCachedCoupes(jsonData)
            } catch (e) {
                console.error(e)
            } finally {
                setShouldFetch(false)
            }
        }
    }, [setCachedCoupes, shouldFetch])

    useEffect(() => {
        fetchCoupes()
    }, [fetchCoupes])

    return { cachedCoupes }
}
